import React from "react";
import type { SectionComponentProps } from "../../registry.js";
import { BookingGrid, type BookingGridProps } from "../../../scheduling/components/BookingGrid.js";

export function ReservationsInline({ props, clientId }: SectionComponentProps) {
  const config = props as BookingGridProps;
  return (
    <section className="py-20 px-6 bg-muted/30" id="reservations">
      <BookingGrid {...config} clientId={clientId} />
    </section>
  );
}
